import React from 'react';

import { Main } from '/imports/refundPolicy/ui/atoms';
import Refund from '/imports/refundPolicy/ui/components/Refund';
import { replaceString } from '/imports/core/ui/helpers';
import SubscriptionCancellation from '/imports/refundPolicy/ui/components/SubscriptionCancellation';
import useDomain from '/imports/core/hooks/useDomain';
import useIntl from '/imports/core/api/useIntl';

function RefundSubscriptionPolicy() {
  const { t } = useIntl();
  const { getContactEmail } = useDomain();
  const getContactSupportLink = () => {
    const value = getContactEmail();
    let replacedValue = {};
    if (value?.value) {
      replacedValue = {
        TITLE: value.title,
        'contact@resumedone.io': value.value,
      };
    } else {
      replacedValue = {
        TITLE: value,
        'contact@resumedone.io': value,
      };
    }

    return replaceString(t('refund.para2_sub2'), replacedValue);
  };
  return (
    <Main>
      <SubscriptionCancellation getContactSupportLink={getContactSupportLink} />
      <Refund getContactSupportLink={getContactSupportLink} />
    </Main>
  );
}

export default RefundSubscriptionPolicy;
